'use strict';

var SystemStatusFlightRenderersFactory = function SystemStatusFlightRenderersFactory($interpolate) {
  var messageTemplate = $interpolate('<a href="#" data-click="true" uid="{{uid}}">view message</a>');
  var statusFlightSentMessageViewRenderer = function statusFlightSentMessageViewRenderer(columnContext, row, columnfield, value, defaultvalue) {
    var data = {
      uid: row
    };
    return defaultvalue.replace('>' + value + '<', '>' + messageTemplate(data) + '<');
  };
  return {
    statusFlightSentMessageView: statusFlightSentMessageViewRenderer
  };
};
SystemStatusFlightRenderersFactory.$inject = ['$interpolate'];
module.exports = SystemStatusFlightRenderersFactory;